import React from "react";

const PopupCommon = (props) => {
  const { children, onClickFalse, className, isVisible, style, size } = props;

  return (
    <div className={`popup-common  ${isVisible ? "popup-common-visible" : ""}`} onClick={onClickFalse}>
      <div className={`container ${size} ${className}`} style={style} onClick={(e) => e.stopPropagation()}>
        {children}
      </div>
    </div>
  );
};

export default PopupCommon;
